const article = {
	slug: "owasp-agent-security-gap",
	title: "AI Agents Ship Code. They Do Not Ask What Can Go Wrong.",
	date: "25 May 2026",
	updated: null,
	description:
		"AI coding agents write clean, passing, deployable code, but they do not know your attack surface. The fix is to constrain the agent before it writes, the way test-driven development constrains code before it exists.",
	keywords: [
		"AI security",
		"agentic AI",
		"OWASP Top 10",
		"DevSecOps",
		"pre-deployment security",
		"AI coding agents",
	],
	tldr: "Security audits done after code is written confirm what you already built instead of constraining what you build. A security skill that fires before an agent writes in a risk area closes the gap where incidents actually happen.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, May 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: "agent-security-checklist",
	markdown: `AI coding agents have gotten very good at shipping code.

They have not gotten good at asking what can go wrong.

I saw this on my own project. One public URL, no rate limit, and bots found it six months later. Google reinstated the project after I fixed it, and the fix held. But the gap is not mine alone. I see the same blind spot in enterprise teams with 50-person engineering orgs. The agent writes clean, passing, deployable code. It does not know your attack surface.

## The test-driven parallel

Most security tools in this space scan code after it is written. Findings go into a report. The report becomes a negotiation. Some things get fixed.

The parallel that changed how I thought about this is TDD.

In test-driven development, you write the test before the implementation. The test defines what correct looks like before any code exists to be defensive about. Security audits done after the fact have the same problem as tests written after the code. They confirm what you already built. They don't constrain what you build.

Adding "follow OWASP" to your requirements spec is aspiration. A skill that fires before writing a specific route asks a specific question. That difference is where incidents happen.

## Constrain the agent before it writes

I open-sourced claude-security-engineer: ten skills for Claude Code, one per OWASP Top 10 category. Each one runs before your agent writes anything in that risk area. No code yet. No patterns to defend. The agent knows the constraint before it makes a single design decision.

Free. Installs in 30 seconds. Repo: [github.com/swapniltamse/claude-security-engineer](https://github.com/swapniltamse/claude-security-engineer)

For developers, it stops the gap before it becomes a suspension email. For enterprise teams, it is something real to hand your CISO when they ask how you are shipping with AI.

## What comes next

OWASP released the Agentic Top 10 in December. Ten risk categories specifically for autonomous agent systems: goal hijacking, tool misuse, rogue agents, cascading failures across agent meshes.

Phase 1 covers the code your agent writes. Phase 2 covers the agent itself.

Fork it. Extend it. Add skills for your stack.`,
};

export default article;
